import { useGraphqlMutation } from "@bsm/component";
import { TNotification } from "@bsm/graphql";

export const useNotificationMarkAllAsReadMutation = () => {
    return useGraphqlMutation<TNotification[]>(gql);
};

const gql = `
    mutation($data: [JSONObject!]) {
        saveNotification(data: { datas: $data }) {
            ids
        }
    }
`;
